import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section about">
            <h3>À propos</h3>
            <p>
              NaturoBook est un outil de prise de rdv en ligne destiné aux naturopathes.
            </p>
            <p>
              Developpé par ADICOTECH.
            </p>
          </div>
          
          <div className="footer-section contact">
            <h3>Contact</h3>
            <p>
              {/* <i className="icon-map"></i> 25 rue des Plantes, 75014 Paris<br />
              <i className="icon-phone"></i> 01 23 45 67 89<br /> */}
              <i className="icon-email"></i> contact.naturobook@adicotech.fr
            </p>
          </div>
          
          <div className="footer-section links">
            <h3>Liens rapides</h3>
            <ul>
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/booking">Rendez-vous</Link></li>
              <li><Link to="/terms-of-service">Conditions d'utilisation</Link></li>
              <li><Link to="/privacy-policy">Politique de confidentialité</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} ADICOTECH - Tous droits réservés
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;